import { GoabIcon } from "@abgov/react-components";

export const ErrorMessage = ({ error, getResourceValue }) => {
    if (!error) return null;
    
    return (
        <div className="error-msg" role="alert">
            <GoabIcon type="warning" theme="filled" size="small" fillColor="red"></GoabIcon>
            {getResourceValue({ key: error })}
        </div>
    );
};